import { type Field, FieldDataType } from '@domains/subscription/priv/types'
import type { Control, FieldValues, Path } from 'react-hook-form'
import { BooleanInputField } from './boolean'
import { EnumInputField } from './enum'
import { IntegerInputField } from './integer'

export interface FeatureInputFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label: string
  field: Field
}

export const FeatureInputField = <T extends FieldValues>({ field, ...props }: FeatureInputFieldProps<T>) => {
  switch (field.type) {
    case FieldDataType.BOOLEAN:
      return <BooleanInputField {...props} field={field} />
    case FieldDataType.INTEGER:
      return <IntegerInputField {...props} field={field} />
    case FieldDataType.ENUM:
      return <EnumInputField {...props} field={field} />
  }
}
